<template>
  <section
    class="content-current"
    style="margin-top: 60px; margin-bottom: 60px"
  >
    <div class="card-header">
      <h4 class="box-title">
        <i class="fa fa-info-circle fa-fw"></i><label>اطلاعات واچر </label>
      </h4>
    </div>
    <SKLPrintTicket v-if="isLoading" />
    <div
      v-if="!isLoading"
      class="content-current"
      style="margin-top: 20px"
      id="voucherdata"
      ref="voucherdata"
    >
      <div ref="voucherdata">
        <div
          style="
            direction: rtl;
            display: flex;
            border: 1px solid;
            padding: 20px;
          "
        >
          <div style="width: 15%">
            <img
              v-if="status === 6"
              src="/img/Cancel.png"
              alt="City tours"
              data-retina="true"
              style="cursor: pointer"
            />
          </div>
          <div style="width: 85%; display: grid; text-align: left; float: left">
            <barcode v-bind:value="voucherNumber" format="CODE39" height="40">
            </barcode>
          </div>
        </div>
        <div
          style="
            direction: rtl;
            display: flex;
            border: 1px solid;
            padding: 20px;
          "
        >
          <div style="width: 15%">
            <img
              src="/img/pdk_logo.png"
              width="300px"
              height="47px"
              alt="City tours"
              data-retina="true"
              @click.prevent="gotoHome"
              style="cursor: pointer"
            />
          </div>
          <div style="width: 85%; display: grid; text-align: left">
            <label>
              تاریخ رزرو:
              <span> {{ inDate | persianDate("jYYYY/jMM/jDD") }}</span></label
            >
            <label>
              شماره رزرو: <span> {{ reserveNumber }}</span></label
            >
          </div>
        </div>
        <div
          style="
            background-color: #e7e7e7;
            border-left: 1px solid black !important;
            border-right: 1px solid black !important;
            border-top: 1px solid black !important;
            padding: 4px !important;
            text-align: center !important;
            margin-top: 3px !important;
            box-shadow: inset 0 0 0 1000px rgb(231, 231, 231) !important;
            color: black !important;
          "
        >
          اطلاعات رزرو
        </div>
        <div
          style="
            direction: rtl;
            border: 1px solid black;
            padding: 6px;
            text-align: right;
          "
        >
          <div
            style="
              margin-bottom: 50px;
              margin-right: 1%;
              display: contents;
              font-size: 10pt;
            "
            id="time"
          >
            <label style="margin-right: 1%; width: 30%"
              ><span style="font-size: 8pt !important">تامین کننده:</span>
              {{ providerName }}</label
            >

            <label style="margin-right: 1%; width: 30%"
              ><span>فروشنده :</span>{{ sellerName }}<span></span>
            </label>
            <label
              style="margin-right: 1%; width: 30%; font-size: 8pt !importan"
              ><span>خدمات :</span>{{ serviceName }}<span></span>
            </label>
          </div>
          <div
            style="
              margin-bottom: 50px;
              margin-right: 1%;
              display: contents;
              font-size: 10pt;
            "
            id="time"
          >
            <label style="margin-right: 1%; width: 30%"
              ><span>تاریخ ورود :</span>
              {{ arrivalDate | persianDate("YYYY/MM/DD") }}</label
            >

            <label style="margin-right: 1%; width: 30%"
              ><span>تعداد مهمان:</span>{{ adultCount }} بزرگسال -
              {{ childCount }} کودک-<span>
                <span> {{ infantCount }} نوزاد </span></span
              >
            </label>
            <label style="margin-right: 1%; width: 30%"
              ><span>مجموع رزروشده : </span>{{ guestCount }} نفر<span></span>
            </label>
          </div>
          <div
            style="
              margin-bottom: 50px;
              margin-right: 1%;
              display: contents;
              font-size: 10pt;
            "
            id="time"
          >
            <label style="margin-right: 1%; width: 30%"
              ><span>برنامه زمانی:</span> {{ scheduleTime }}</label
            >

            <label style="margin-right: 1%; width: 30%"
              ><span>شماره واچر:</span>{{ voucherNumber }}<span></span>
            </label>
            <label style="margin-right: 1%; width: 30%">
              <span>شماره پرواز:</span>{{ flightNumber }}<span></span
            ></label>
          </div>
          <div
            style="
              margin-bottom: 50px;
              margin-right: 1%;
              display: contents;
              font-size: 10pt;
            "
            id="time"
          >
            <!-- <label style="margin-right: 1%; width: 30%"
              ><span> مبلغ : </span>
              {{ totalBasePrice | numFormat | rial }}</label
            > -->

            <label style="margin-right: 1%; width: 30%"
              ><span> مبلغ پرداخت شده : </span>{{ totalPrice | numFormat | rial
              }}<span></span>
            </label>
            <label style="margin-right: 1%; width: 30%"> </label>
          </div>

          <br />
          <template v-if="addOnOptionList.length > 0">
            <hr />
            <div
              style="
                margin-bottom: 50px;
                margin-right: 1%;
                display: contents;
                font-size: 10pt;
              "
            >
              <label style="margin-right: 1%; width: 30%"
                ><span style="font-size: 10pt !important"> سایر خدمات</span>
              </label>

              <label style="margin-right: 1%; width: 30%"> </label>
              <label
                style="margin-right: 1%; width: 30%; font-size: 8pt !importan"
              >
              </label>
            </div>

            <div
              v-for="addon in addOnOptionList"
              style="
                margin-bottom: 50px;
                margin-right: 1%;
                display: contents;
                font-size: 10pt;
              "
            >
              <label style="margin-right: 1%; width: 30%"
                ><span style="font-size: 8pt !important"> نوع خدمات:</span>
                {{ addon.addOnOption.name }}</label
              >

              <label style="margin-right: 1%; width: 30%"
                ><span>تعداد :</span> {{ addon.quantity }}<span></span>
              </label>
              <label
                style="margin-right: 1%; width: 30%; font-size: 8pt !importan"
              >
              </label>
            </div>
          </template>
        </div>

        <div
          style="
            background-color: #e7e7e7;
            border-left: 1px solid black !important;
            border-right: 1px solid black !important;
            border-top: 1px solid black !important;
            padding: 4px !important;
            text-align: center !important;
            margin-top: 3px !important;
            box-shadow: inset 0 0 0 1000px rgb(231, 231, 231) !important;
            color: black !important;
          "
        >
          مشخصات مشتری
        </div>
        <div
          style="
            direction: rtl;
            border: 1px solid black;
            padding: 6px;
            text-align: right;
          "
        >
          <div
            style="
              margin-bottom: 50px;
              margin-right: 1%;
              display: contents;
              font-size: 10pt;
            "
            id="time"
          >
            <label style="margin-right: 1%; width: 30%"
              ><span>نام:</span>
              {{ firstName }}
            </label>

            <label style="margin-right: 1%; width: 30%"
              ><span>نام خانوادگی :</span>{{ lastName }}<span></span>
            </label>
            <label style="margin-right: 1%; width: 30%"
              ><span> پست الکترونیک: </span>{{ email }}<span></span>
            </label>
          </div>
          <div
            style="
              margin-bottom: 50px;
              margin-right: 1%;
              display: contents;
              font-size: 10pt;
            "
            id="time"
          >
            <label style="margin-right: 1%; width: 30%"
              ><span> شماره همراه:</span> {{ mobileNumber }}</label
            >

            <label style="margin-right: 1%; width: 30%"
              ><span>پاسپورت :</span>{{ nationalCode }}<span></span>
            </label>
            <label style="margin-right: 1%; width: 30%"> </label>
          </div>
          <div
            style="
              margin-bottom: 50px;
              margin-right: 1%;
              display: contents;
              font-size: 10pt;
            "
            id="time"
          >
            <label style="margin-right: 1%; width: 90%"
              ><span> توضیحات:</span> {{ customerRequest }}</label
            >
          </div>
          <template v-if="bookingGuests.length">
            <hr />
            <div
              style="
                margin-bottom: 50px;
                margin-right: 1%;
                display: contents;
                font-size: 10pt;
              "
            >
              <label style="margin-right: 1%; width: 90%"
                ><span> همراهان </span>
              </label>
            </div>
            <div
              v-for="guest in bookingGuests"
              style="
                margin-bottom: 50px;
                margin-right: 1%;
                display: contents;
                font-size: 10pt;
              "
            >
              <label style="margin-right: 1%; width: 30%"
                ><span v-if="guest.ageCategoryId === 3"> نام بزرگسال :</span>
                <span v-if="guest.ageCategoryId === 2"> نام کودک :</span>
                <span v-if="guest.ageCategoryId === 1"> نام نوزاد :</span>
                {{ guest.firstName }}</label
              >
              <label style="margin-right: 1%; width: 30%">
                <span v-if="guest.ageCategoryId === 3">
                  نام خانوادگی بزرگسال :</span
                >
                <span v-if="guest.ageCategoryId === 2">
                  نام خانوادگی کودک :</span
                >
                <span v-if="guest.ageCategoryId === 1">
                  نام خانوادگی نوزاد :</span
                >
                {{ guest.lastName }}
              </label>
              <label style="margin-right: 1%; width: 30%"
                ><span v-if="guest.ageCategoryId === 3">
                  پاسپورت بزرگسال :</span
                >
                <span v-if="guest.ageCategoryId === 2"> پاسپورت کودک :</span>
                <span v-if="guest.ageCategoryId === 1"> پاسپورت نوزاد :</span>
                {{ guest.nationalCode }}</label
              >
            </div>
          </template>
          <br />
        </div>

        <div
          style="
            background-color: #e7e7e7;
            border-left: 1px solid black !important;
            border-right: 1px solid black !important;
            border-top: 1px solid black !important;
            padding: 4px !important;
            text-align: center !important;
            margin-top: 3px !important;
            box-shadow: inset 0 0 0 1000px rgb(231, 231, 231) !important;
            color: black !important;
          "
        >
          قوانین
        </div>
        <div
          style="
            direction: rtl;
            border: 1px solid black;
            padding: 6px;
            text-align: right;
          "
        >
          <div
            style="
              margin-bottom: 50px;
              margin-right: 1%;
              display: contents;
              font-size: 10pt;
            "
            id="time"
          >
            <p v-html="rules" ref="document"></p>
          </div>

          <br />
        </div>
        <div
          v-if="status === 6"
          style="
            background-color: #e7e7e7;
            border-left: 1px solid black !important;
            border-right: 1px solid black !important;
            border-top: 1px solid black !important;
            padding: 4px !important;
            text-align: center !important;
            margin-top: 3px !important;
            box-shadow: inset 0 0 0 1000px rgb(231, 231, 231) !important;
            color: black !important;
          "
        >
          جزئیات کنسلی
        </div>
        <div
          v-if="status === 6"
          style="
            direction: rtl;
            border: 1px solid black;
            text-align: right;
          "
        >
          <div style="font-size: 10pt" class="row q-gutter-sm">
            <div class="column">
              <div class="col">
                <label style="margin-left: 5px"
                  ><strong> کنسل شده به علت:</strong>
                  {{ cancelReasonTitle }}
                </label>
                <label style="margin-left: 5px"
                  ><strong> در تاریخ:</strong>
                  {{ shamsiCancelDate }}
                </label>
                <label style="margin-left: 5px"
                  ><strong> ساعت:</strong>
                  {{ shamsiCancelTime }}
                </label>
              </div>
            </div>
          </div>

          <template v-if="isRefunded === true && noshowRate > 0">
            <div
              style="
                margin-bottom: 50px;
                margin-left: 5px;
                display: contents;
                font-size: 10pt;
              "
            >
              <label style="margin-left: 5px; width: 90%"
                ><strong> مبلغ {{ noshowRate }} عودت داده شده است</strong>
              </label>
            </div>
          </template>

          <br />
        </div>
      </div>
    </div>

    <div class="btn-align">
      <button type="submit" class="btn-profile" @click="print">چاپ واچر</button>
      <button type="submit" class="btn-profile" @click="toPDF">
        دانلود فایل
      </button>
    </div>
  </section>
</template>
<script>
import store from "../../../../views/tourism/store/index";
import VueBarcode from "vue-barcode";
import SKLPrintTicket from "../../../tourism/SKLPrintTicket.vue";
import exportFiles from "../../../../utils/exportFiles";

export default {
  store,
  components: { barcode: VueBarcode, SKLPrintTicket },

  data() {
    return {
      customerInfo: {
        firstName: "",
        lastName: "",
        mobileNumber: "",
        emailAddress: "",
        isCustomerReserver: true,
        gender: "",
        birthDate: "",
        nationalCode: "",
      },
      providerId: 2,
      sellerName: "",
      barcodeValue: "",
      rules: "",

      logo: "",
      voucherNumber: "",
      providerName: "",
      serviceName: "",
      arriveDate: "",
      guestCount: "",
      adultCount: "",
      childCount: "",
      infantCount: "",
      scheduleTime: "",
      firstName: "",
      lastName: "",
      mobileNumber: "",
      nationalCode: "",
      email: "",
      arrivalDate: "",
      reserveNumber: "",
      flightNumber: "",
      isLoading: false,
      addOnOptionList: [],
      customerRequest: "",
      bookingGuests: [],
      inDate: "",
      status: 0,
      totalBasePrice: 0,
      totalPrice: 0,
      cancelReasonTitle: "",
      isRefunded: false,
      shamsiCancelDate: "",
      shamsiCancelTime: "",
      noshowRate: "",
    };
  },

  created() {
    this.id = this.$route.params.id;
    this.getByVoucher();
  },
  methods: {
    async getByVoucher() {
      this.isLoading = true;
      this.voucherNumber = this.$route.params.id;
      const params = {
        voucherNumber: this.voucherNumber,
        profileId: localStorage.getItem("SourceProfileId"),
      };
      const data = await this.$store.dispatch("getByVoucher", params);
      this.isLoading = false;
debugger
      let bookingDetail = data.data[0];
console.log(bookingDetail,"bookingDetail")
      this.voucherNumber = bookingDetail.voucherNumber;
      this.flightNumber = bookingDetail.description;
      this.reserveNumber = bookingDetail.reserveNumber;
      this.arrivalDate = bookingDetail.arrivalDate;
      this.logo = bookingDetail.bookingProductDetails[0].product.provider.logo;
      this.providerName =
        bookingDetail.bookingProductDetails[0].product.provider.name;
      this.sellerName = bookingDetail.source.name;
      this.serviceName = bookingDetail.bookingProductDetails[0].product.name;
      this.addOnOptionList =
        bookingDetail.bookingProductDetails[0].bookingProductDetailAddOnOptions;
      this.guestCount = bookingDetail.pax;
      this.adultCount = bookingDetail.adult;
      this.childCount = bookingDetail.child;
      this.infantCount = bookingDetail.infant;
      this.bookingGuests = bookingDetail.bookingGuests.filter(
        (p) => p.isCustomerReserver === false
      );
      const mainGuest = bookingDetail.bookingGuests.find(
        (p) => p.isCustomerReserver === true
      );
      this.firstName = mainGuest.firstName;
      this.lastName = mainGuest.lastName;
      this.mobileNumber = mainGuest.mobileNumber;
      this.email = mainGuest.emailAddress;
      this.nationalCode = mainGuest.nationalCode;
      this.rules =
        bookingDetail.bookingProductDetails[0].product.termsAndConditions;
      this.scheduleTime =
        bookingDetail.bookingProductDetails[0].schedule.description;
      this.logo = bookingDetail.bookingProductDetails[0].product.provider.logo;
      this.customerRequest = bookingDetail.customerRequest;
      this.customerRequest = bookingDetail.customerRequest;
      this.inDate = bookingDetail.inDate;
      this.status = bookingDetail.status;

      this.totalBasePrice =
        bookingDetail.bookingFinancialDetails[0].totalBasePrice;
      this.totalPrice = bookingDetail.bookingFinancialDetails[0].totalPrice;
      this.cancelReasonTitle = bookingDetail.bookingCancel[0].cancelReasonTitle;
      this.isRefunded = bookingDetail.bookingCancel[0].isRefunded;
      this.shamsiCancelDate = bookingDetail.bookingCancel[0].shamsiCancelDate;
      this.shamsiCancelTime =
        bookingDetail.bookingCancel[0].shamsiCancelTime.substring(0, 8);
      this.noshowRate = bookingDetail.bookingCancel[0].noshowRate;
    },
    toPDF() {
      var fileName = "PDK_Voucher_" + this.voucherNumber;
      exportFiles.ExportToPDF(this.$refs.voucherdata, fileName, null, null);
    },
    print() {
      const localOptions = {
        styles: [
          "https://dariushgroup.com/css/bootstrap.css",
          "https://unpkg.com/kidlat-css/css/kidlat.css",
          "https://dariushgroup.com/css/printTicket.css",
        ],
      };
      this.$htmlToPaper("voucherdata", localOptions, () => {});
    },
  },
};
</script>

<style scoped>
.header-title {
  background-color: #e7e7e7;
  border-left: 1px solid black !important;
  border-right: 1px solid black !important;
  border-top: 1px solid black !important;
  padding: 4px !important;
  text-align: center !important;
  margin-top: 3px !important;
  box-shadow: inset 0 0 0 1000px rgb(231, 231, 231) !important;
  color: black !important;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

caption {
  font-size: 28px;
  margin-bottom: 15px;
}

th {
  background-color: #f0f0f0;
}

h4,
p {
  margin: 0px;
}
</style>